import React from 'react';
import '../../styles/main.scss';
import MenuHome from '../../components/MenuHome';
import MenuComputerScience from '../../components/MenuComputerScience';

const Algorithms = () => {
  return <div>
        <div className="title">Algorithms</div>
        <div class="caption"></div>
        <MenuHome />
        <MenuComputerScience />
  </div>;
};

export default Algorithms;